import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Produk from "@/pages/Produk";
import Proses from "@/pages/Proses";
import Tentang from "@/pages/Tentang";
import Garansi from "@/pages/Garansi";
import Portofolio from "@/pages/Portofolio";
import Kontak from "@/pages/Kontak";

function App() {
  return (
    <BrowserRouter>
      <SmoothScroll>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/produk" element={<Produk />} />
            <Route path="/proses" element={<Proses />} />
            <Route path="/tentang" element={<Tentang />} />
            <Route path="/garansi" element={<Garansi />} />
            <Route path="/portofolio" element={<Portofolio />} />
            <Route path="/kontak" element={<Kontak />} />
          </Routes>
        </Layout>
      </SmoothScroll>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}

export default App;
